
import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-jd-proposal-view',
	templateUrl: './jd-proposal-view.component.html'
})

export class JdProposalViewComponent implements OnInit {

	@Input('proposal') proposal = [];

	constructor() {
	}

	ngOnInit() {
		console.log("JD", this.proposal);
	}

	getPropostalStatus(statusID) {
		switch(statusID)
		{
			case "EA": return "Em Aprovação";
			case "AP": return "Aprovada";
			case "CA": return "Cancelada";
			default: return "";
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/JDproposal-view/jd-proposal-view.component.ts